<template>
  <div class="weui-cell" :class="{ 'disabled': disabled }">
    <div class="weui-cell__bd">
      <textarea
        class="weui-textarea"
        :rows="rows"
        :placeholder="placeholder"
        v-model="currentValue"
        :disabled="disabled" />
      <div class="weui-textarea-counter"><span>{{ counter }}</span>/{{ maxLength }}</div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        rows: {
            type: Number,
            default: 2,
        },
        placeholder: {
            type: String,
            default: null,
        },
        value: {
            type: [String, Number],
            default: null,
        },
        maxLength: {
            type: Number,
            default: 100,
        },
    },
    data() {
        return {
            currentValue: '',
        };
    },
    watch: {
        value(val) {
            this.currentValue = val;
        },
        currentValue(newVal) {
            if (this.maxLength && newVal && newVal.length > this.maxLength) {
                this.currentValue = newVal.slice(0, this.maxLength);
            }
            this.$emit('input', this.currentValue);
        },
    },
    mounted() {
        this.currentValue = this.value;
    },
    computed: {
        counter() {
            return this.currentValue.length;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/weui/textarea/Index.vue